import {FC, useEffect, useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {isNotEmpty, toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import {initialUser, User} from '../core/_models'
import clsx from 'clsx'
import {useListView} from '../core/ListViewProvider'
import {UsersListLoading} from '../components/loading/UsersListLoading'
import {createUser, updateUser} from '../core/_requests'
import {useQueryResponse} from '../core/QueryResponseProvider'
import { valuesEqual } from '@aws-amplify/datastore/lib-esm/util';
import { date } from 'yup/lib/locale';



type Props = {
  isUserLoading: boolean
  user: User
  roles: any
}

const editUserSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  name: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Name is required')
})

const UserEditModalForm: FC<Props> = ({user, isUserLoading, roles}) => {

  console.log(user);
  const {setItemIdForUpdate} = useListView()
  const {refetch} = useQueryResponse()
  const [userForEdit] = useState<User>({
    ...user,
    avatar: user.avatar || initialUser.avatar,
    name: user.name || initialUser.name,
    email: user.email || initialUser.email,
    phone_number: user.phone_number || initialUser.phone_number,
    gender: user.gender || initialUser.gender,
    roleId: user.roleId || initialUser.roleId,
    d_o_b: user.d_o_b || initialUser.d_o_b,
    social_security: user.social_security || initialUser.social_security
  })

  const [selectedRole, setSelectedRole] = useState(Number);
  const [dob, setDob] = useState('');

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  const blankImg = toAbsoluteUrl('/media/svg/avatars/blank.svg')
  const userAvatarImg = toAbsoluteUrl(`/media/${userForEdit.avatar}`)

  const formik = useFormik({
    initialValues: userForEdit,
    validationSchema: editUserSchema,
    onSubmit: async (values, {setSubmitting}) => {
      setSubmitting(true)
      try {
        if (isNotEmpty(values.id)) {
          values.roleId = selectedRole;
          await updateUser(values)
        } else {
          console.log(values);
          values.roleId = selectedRole; // i am adding this manually, i dont know why it is not getting along with form other fields
          await createUser(values)
        }
      } catch (ex) {
        console.error(ex)
      } finally {
        setSubmitting(true)
        cancel(true)
      }
    },
  })

  const handleChange = (e:any) => {
    setSelectedRole(e.target.value);
  }

  const handleDoBChange = (e:any) => {
    const date = new Date(e.target.value);
    setDob(date.toISOString().substr(0, 10));
  }

  return (
    <>
      <form id='kt_modal_add_user_form' className='form' onSubmit={formik.handleSubmit} noValidate>
        {/* begin::Scroll */}
        <div
          className='d-flex flex-column scroll-y me-n7 pe-7'
          id='kt_modal_add_user_scroll'
          data-kt-scroll='true'
          data-kt-scroll-activate='{default: false, lg: true}'
          data-kt-scroll-max-height='auto'
          data-kt-scroll-dependencies='#kt_modal_add_user_header'
          data-kt-scroll-wrappers='#kt_modal_add_user_scroll'
          data-kt-scroll-offset='300px'
        >
          {/* begin::Input group */}
          <div className='fv-row mb-7'>
            {/* begin::Label */}
            <label className='d-block fw-semibold fs-6 mb-5'>Avatar</label>
            {/* end::Label */}

            {/* begin::Image input */}
            <div
              className='image-input image-input-outline'
              data-kt-image-input='true'
              style={{backgroundImage: `url('${blankImg}')`}}
            >
              {/* begin::Preview existing avatar */}
              <div
                className='image-input-wrapper w-125px h-125px'
                style={{backgroundImage: `url('${userAvatarImg}')`}}
              ></div>
              {/* end::Preview existing avatar */}

              {/* begin::Label */}
              {/* <label
              className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
              data-kt-image-input-action='change'
              data-bs-toggle='tooltip'
              title='Change avatar'
            >
              <i className='bi bi-pencil-fill fs-7'></i>

              <input type='file' name='avatar' accept='.png, .jpg, .jpeg' />
              <input type='hidden' name='avatar_remove' />
            </label> */}
              {/* end::Label */}

              {/* begin::Cancel */}
              {/* <span
              className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
              data-kt-image-input-action='cancel'
              data-bs-toggle='tooltip'
              title='Cancel avatar'
            >
              <i className='bi bi-x fs-2'></i>
            </span> */}
              {/* end::Cancel */}

              {/* begin::Remove */}
              {/* <span
              className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
              data-kt-image-input-action='remove'
              data-bs-toggle='tooltip'
              title='Remove avatar'
            >
              <i className='bi bi-x fs-2'></i>
            </span> */}
              {/* end::Remove */}
            </div>
            {/* end::Image input */}

            {/* begin::Hint */}
            {/* <div className='form-text'>Allowed file types: png, jpg, jpeg.</div> */}
            {/* end::Hint */}
          </div>
          {/* end::Input group */}

          {/* begin::Input group */}
          <div className='row mb-7'>
            <div className='col-6'>
              {/* begin::Label */}
              <label className='required fw-semibold fs-6 mb-2'>Full Name</label>
              {/* end::Label */}
              {/* begin::Input */}
              <input
                placeholder='John'
                {...formik.getFieldProps('name')}
                type='text'
                name='name'
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  {'is-invalid': formik.touched.name && formik.errors.name},
                  {
                    'is-valid': formik.touched.name && !formik.errors.name,
                  }
                )}
                autoComplete='off'
                disabled={formik.isSubmitting || isUserLoading}
              />
              {formik.touched.name && formik.errors.name && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.name}</span>
                  </div>
                </div>
              )}
              {/* end::Input */}
            </div>              
            <div className='col-6'>
              <label className='required fw-semibold fs-6 mb-2'>Gender</label>
                <select
                  className='form-select form-select-solid form-select-lg fw-semibold'
                  {...formik.getFieldProps('gender')}
                >
                  <option value=''>Select Gender</option>
                  <option value='0' selected={formik.initialValues.gender === '0'}>Male</option>
                  <option value='1' selected={formik.initialValues.gender === '1'}>Female</option>
                </select>
                {formik.touched.gender && formik.errors.gender && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.gender}</div>
                  </div>
                )}
              </div>
          </div>
          {/* end::Input group */}
          {/* begin::Input group */}
          <div className='row mb-7'>
            <div className='col-6'>
              {/* begin::Label */}
              <label className='required fw-semibold fs-6 mb-2'>Email</label>
              {/* end::Label */}

              {/* begin::Input */}
              <input
                placeholder='Email'
                {...formik.getFieldProps('email')}
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  {'is-invalid': formik.touched.email && formik.errors.email},
                  {'is-valid': formik.touched.email && !formik.errors.email}
                )}
                type='email'
                name='email'
                autoComplete='off'
                disabled={formik.isSubmitting || isUserLoading}
              />
              {/* end::Input */}
              {formik.touched.email && formik.errors.email && (
                <div className='fv-plugins-message-container'>
                  <span role='alert'>{formik.errors.email}</span>
                </div>
              )}
            </div>

            <div className='col-6'>
              {/* begin::Label */}
              <label className='fw-semibold fs-6 mb-2'>Contact</label>
              {/* end::Label */}

              {/* begin::Input */}
              <input
                placeholder='(without hyphen or spaces)'
                {...formik.getFieldProps('phone_number')}
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  {'is-invalid': formik.touched.phone_number && formik.errors.phone_number},
                  {'is-valid': formik.touched.phone_number && !formik.errors.phone_number}
                )}
                type='phone'
                name='phone_number'
                autoComplete='off'
                disabled={formik.isSubmitting || isUserLoading}
              />
              {/* end::Input */}
              {formik.touched.phone_number && formik.errors.phone_number && (
                <div className='fv-plugins-message-container'>
                  <span role='alert'>{formik.errors.phone_number}</span>
                </div>
              )}
            </div>
          </div>
          {/* end::Input group */}

          {/* begin::Input group */}
          <div className='row mb-7'>
            <div className='col-6'>
              {/* begin::Label */}
              <label className='required fw-semibold fs-6 mb-2'>DOB</label>
              {/* end::Label */}

              {/* begin::Input */}
              <input
                placeholder='Select date'
                {...formik.getFieldProps('d_o_b')}
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  {'is-invalid': formik.touched.d_o_b && formik.errors.d_o_b},
                  {'is-valid': formik.touched.d_o_b && !formik.errors.d_o_b}
                
                  )}
                type='date'
                name='d_o_b'
                value={dob}
                onChange={handleDoBChange}
                autoComplete='off'
                disabled={formik.isSubmitting || isUserLoading}
              />
              {/* end::Input */}
              {formik.touched.d_o_b && formik.errors.d_o_b && (
                <div className='fv-plugins-message-container'>
                  <span role='alert'>{formik.errors.d_o_b}</span>
                </div>
              )}
            </div>

            <div className='col-6'>
              {/* begin::Label */}
              <label className='fw-semibold fs-6 mb-2'>Social Security #</label>
              {/* end::Label */}

              {/* begin::Input */}
              <input
                placeholder='(Social Security no.)'
                {...formik.getFieldProps('social_security')}
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  {'is-invalid': formik.touched.social_security && formik.errors.social_security},
                  {'is-valid': formik.touched.social_security && !formik.errors.social_security}
                )}
                type='Number'
                name='social_security'
                autoComplete='off'
                disabled={formik.isSubmitting || isUserLoading}
              />
              {/* end::Input */}
              {formik.touched.social_security && formik.errors.social_security && (
                <div className='fv-plugins-message-container'>
                  <span role='alert'>{formik.errors.social_security}</span>
                </div>
              )}
            </div>
          </div>
          {/* end::Input group */}



          {/* begin::Input group */}
          <div className='fv-row mb-7'>
            {/* begin::Label */}
            <label className='required fw-semibold fs-6 mb-5'>Role</label>
            {/* end::Label */}
            {/* begin::Roles */}
            {/* begin::Input row */}
            <div className='d-flex fv-row'>
              {/* begin::Radio */}
              <div className='form-check form-check-custom form-check-solid'>
                {/* begin::Input */}
                  {roles && roles.map((role:any) => ( 
                    <div key={role.id} style={{marginRight:10}}> 
                      <input type="radio"
                        name="roleId"
                        className="form-check-input me-3"
                        value={role.id}
                        onChange={handleChange}
                        checked={formik.initialValues.roleId === role.id}
                      />
                      <label>{role.name}</label>
                  </div> 
                  ))}
                {/* end::Input */}
              {/* end::Radio */}
            </div>
            {/* end::Input row */}
          </div>
        </div>
        {/* end::Scroll */}

        {/* begin::Actions */}
        <div className='text-center pt-15'>
          <button
            type='reset'
            onClick={() => cancel()}
            className='btn btn-light me-3'
            data-kt-users-modal-action='cancel'
            disabled={formik.isSubmitting || isUserLoading}
          >
            Discard
          </button>

          <button
            type='submit'
            className='btn btn-primary'
            data-kt-users-modal-action='submit'
            disabled={isUserLoading || formik.isSubmitting || !formik.isValid || !formik.touched}
          >
            <span className='indicator-label'>Submit</span>
            {(formik.isSubmitting || isUserLoading) && (
              <span className='indicator-progress'>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        {/* end::Actions */}
      </div>
    </form>
      {(formik.isSubmitting || isUserLoading) && <UsersListLoading />}
    </>
  )
}

export {UserEditModalForm}
